import { render, staticRenderFns } from "./UcContractEvents.yaml?vue&type=template&id=428858ba&component"
import script from "./UcContractEvents.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractEvents.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports